(function () {
  function getPriceValue(priceEl) {
    if (!priceEl) return null;

    var dataPrice = priceEl.getAttribute('data-currentprice');

    if (dataPrice && !isNaN(Number(dataPrice))) {
      return Number(dataPrice);
    }

    var text = priceEl.textContent || '';
    var cleaned = text
      .replace(/[^\d.,]/g, '')
      .replace(/\s/g, '');

    if (!cleaned) return null;

    if (cleaned.includes(',') && cleaned.includes('.')) {
      cleaned = cleaned.replace(/,/g, '');
    } else if (cleaned.includes(',')) {
      cleaned = cleaned.replace(',', '.');
    }

    var parsed = parseFloat(cleaned);

    if (isNaN(parsed)) return null;

    return parsed * 100;
  }

  function updateBundlerSaveLabels() {
    var containers = document.querySelectorAll('.bundler-target-element .bndlr-container');

    containers.forEach(function (container) {
      var oldPriceEl = container.querySelector('.bndlr-total-price .bndlr-old-price');
      var newPriceEl = container.querySelector('.bndlr-total-price .bndlr-new-price');

      var oldPrice = getPriceValue(oldPriceEl);
      var newPrice = getPriceValue(newPriceEl);

      if (!oldPrice || !newPrice || oldPrice <= newPrice) {
        container.removeAttribute('data-bundler-save-label');
        return;
      }

      var savePercent = Math.round(((oldPrice - newPrice) / oldPrice) * 100);

      if (!savePercent || savePercent <= 0) {
        container.removeAttribute('data-bundler-save-label');
        return;
      }

      container.setAttribute('data-bundler-save-label', 'SAVE ' + savePercent + '%');
    });
  }

  function initBundlerObserver() {
    updateBundlerSaveLabels();

    var observer = new MutationObserver(function () {
      updateBundlerSaveLabels();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['data-currentprice', 'class', 'style']
    });

    document.addEventListener('change', function (event) {
      if (event.target.closest('.bundler-target-element')) {
        setTimeout(updateBundlerSaveLabels, 100);
        setTimeout(updateBundlerSaveLabels, 500);
      }
    });

    document.addEventListener('click', function (event) {
      if (event.target.closest('.bundler-target-element')) {
        setTimeout(updateBundlerSaveLabels, 100);
        setTimeout(updateBundlerSaveLabels, 500);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBundlerObserver);
  } else {
    initBundlerObserver();
  }

  window.addEventListener('load', function () {
    updateBundlerSaveLabels();
    setTimeout(updateBundlerSaveLabels, 500);
    setTimeout(updateBundlerSaveLabels, 1500);
  });
})();